'use client';

import React from 'react';
import { IconPinPlus } from './icons';

/**
 * "Pick on map": the one name and the one icon for choosing a stop on the
 * map, at the right edge of every phone search field (empty peek, the add
 * box). Labelled, so it never reads as a stray glyph.
 */
export default function PickOnMapButton({ onClick, disabled = false }: { onClick: () => void; disabled?: boolean }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title="Pick a spot on the map"
      className="flex h-9 min-h-0 min-w-0 flex-none items-center gap-1 whitespace-nowrap rounded-full border-0 bg-tp-brand-soft px-2.5 text-[13px] font-semibold text-tp-brand transition-colors duration-150 ease-tp-out [@media(hover:hover)]:hover:bg-[#dce9fb] active:bg-[#dce9fb] disabled:bg-tp-surface disabled:text-tp-faint focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tp-brand/45"
      data-testid="trip-pin-toggle"
    >
      <IconPinPlus className="h-4 w-4 flex-none" />
      Pick on map
    </button>
  );
}

